import request from "./request";

// 注册
export const register = (data) =>
  request.post("/zzauthority/user/portal/register", data);
// 获取验证码
export const sendphoneyz = (data) =>
  request.post("/zzauthority/uc/sendVerificationCode", data);
// 忘记密码
export const forgetPassword = (data) =>
  request.post("/zzauthority/user/portal/forgetPassword", data);
// 登录
export const loginPassword = (data) =>
  request.post("/zzauthority/user/portal/loginPassword", data);
export const loginToken = (data) =>
  request.post("/zzauthority/user/portal/loginByToken", data);
// 退出
export const loginOut = (data) =>
  request.post("/zzauthority/user/portal/loginOut", data);
// 版本信息
export const getListTrends = (data) =>
  request.get("/zzauthority/platform/update/trends/getList", { params: data });
// 获取是否升级状态
export const whetherPublish = (data) =>
  request.get("/zzauthority/platform/update/trends/whetherPublish", {
    params: data,
  });
//  行业分类查询
export const getTreeClassify = (data) =>
  request.get("/zzauthority/industry/classify/getTree", { params: data });

// 租户所属行业列表
export const getRelation = (data) =>
  request.get("/zzauthority/tenant/industry/classify/relation/getList/", {
    params: data,
  });
// 查询租户企业信息
export const getTenantEnterpriseList = (data) =>
  request.get("/zzauthority/tenant/getTenantEnterpriseList", { params: data });
// 获取企业信息
export const getInformationInfo = (data) =>
  request.get("/zzauthority/user/portal/getInformationInfo", { params: data });
// 获取行业动态列表
export const getIndustryNewsList = (data) =>
  // 发起 GET 请求获取行业新闻列表
  request.get("/zzauthority/industry/getNewsList", { params: data });
// 获取行业动态详情
export const getIndustryNewsDetail = (data) =>
  request.get("/zzauthority/industry/getNewsDetail", { params: data });
// 招标信息查询
export const getPublicEndBdList = (data) =>
  request.post("/customers/bdElectricTenderPurchase/getPublicEndBdList", data);
// 询报价列表
export const getPublicEndList = (data) =>
  request.get("/inquiry/inquiry/getPublicEndList", { params: data });
// 查询公众端数量
export const getPublicEndCount = (data) =>
  request.post("/zzauthority/tenant/getPublicEndCount", data);
//获取公司列表
export const getCompanyList = (data) =>
  request.post("/zzauthority/EnterpriseInfo/list", data);
export const getCompanyDetails = (data) =>
  request.get("/zzauthority/EnterpriseInfo/getDetail", {
    params: data,
  });

//查询产品类表
export const getProductList = (data) =>
  request.get("/zzauthority/rProduct/getPublicList", {
    params: data,
  });

export const getProductDetails = (data) =>
  request.get("/zzauthority/rProduct/getDetail", {
    params: data,
  });
export const increasePageViewsUrl = (data) =>
  request.put("/zzauthority/rProduct/increasePageViews", data);

//查询行业分类
export const getCategoriesListUrl = (data) =>
  request.get(`/zzauthority/rIndustryCategories/getList`, { params: data });
//获取服务
export const getService = (data) =>
  request.get(`/zzauthority/rService/getList`, { params: data });
export const getServiceRList = (data) =>
  request.get(`/zzauthority/rService/getRList`, { params: data });
export const getServiceById = (data) =>
  request.post(`/zzauthority/rService/getById`, data);
//获取企业咨询
export const getNewsList = (data) =>
  request.get(`/zzauthority/rDynamic/getPublicList`, { params: data });
//获取企业咨询详情
export const getNewsDetails = (data) =>
  request.get(`/zzauthority/rDynamic/getDetail`, { params: data });
//企业咨询点赞 /zzauthority/rDynamic/increaseLikeNums
export const increaseLikeNums = (data) =>
  request.put(`/zzauthority/rDynamic/increaseLikeNums`, data);
//企业咨询浏览 /zzauthority/rDynamic/increasePageViews
export const increasePageViews = (data) =>
  request.put(`/zzauthority/rDynamic/increasePageViews`, data);
export const editTenantEnterprise = (data) =>
  request.post(`/zzauthority/tenant/editTenantEnterprise`, data);
export const getEnterpriseInfo = (data) =>
  request.get(`/zzauthority/EnterpriseInfo/${data.id}`, {
    params: data,
  });

//商品价格 /spider/queryGoodDetailInfo  goodsPriceId
export const queryGoodDetailInfo = (data) =>
  request.get(`/spider/queryGoodDetailInfo`, {
    params: data,
  });
//订单 /spider/querySysGoodsPriceInfo  goodsId
export const querySysGoodsPriceInfo = (data) =>
  request.get(`/spider/querySysGoodsPriceInfo`, {
    params: data,
  });

//获取商品 /zzauthority/pubIndex/getSXGoodsInfo
export const getSXGoodsInfo = (data) =>
  request.get(`/zzauthority/pubIndex/getSXGoodsInfo`, {
    params: data,
  });

//生成订单 /spider/saveSysOrder
export const saveSysOrder = (data) =>
  request.post(`/spider/saveSysOrder`, data);
//查询订单列表
export const querySysOrderPageList = (data) =>
  request.post(`/spider/querySysOrderPageList`, data);
// 获取租户企业信息 /zzauthority/user/portal/getInformationInfo/
// export const getInformationInfo = (data) =>
//   request.get(`/zzauthority/user/portal/getInformationInfo`, {
//     params: data,
//   });
